import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import gigifyLogo from '../../assets/Logo/GIGiFY Logo Horizontal with tagline.png';
import facebookIcon from '../../assets/Images/FacebookIcon.png';
import twitterIcon from '../../assets/Images/XTwitterIcon.png';
import instagramIcon from '../../assets/Images/InstagramIcon.png';
import linkedinIcon from '../../assets/Images/LinkedInIcon.png';

const DesktopFooter = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [scaleFactor, setScaleFactor] = useState(window.innerWidth / 1440);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setScaleFactor(window.innerWidth / 1440);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        setEmail("");
      }, 2000);
    }
  };

  // Main container with CSS Grid
  const footerStyle = {
    position: "relative",
    width: "100%",
    minHeight: `${150 * scaleFactor}px`,
    display: "grid",
    gridTemplateColumns: "35% 30% 35%",
    gridTemplateRows: `${135 * scaleFactor}px ${15 * scaleFactor}px`,
    gridTemplateAreas: `
      "logo nav newsletter"
      "copyright copyright copyright"
    `,
    overflow: "visible",
    fontFamily: "Montserrat, sans-serif",
    background: "transparent"
  };

  // Logo area styles
  const logoAreaStyle = {
    gridArea: "logo",
    position: "relative",
    zIndex: 3,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    paddingLeft: `${1 * scaleFactor}px`,
    paddingTop: `-${5 * scaleFactor}px`
  };

  // Logo styles with responsive scaling
  const logoStyle = {
  width: `${400 * scaleFactor}px`,  // Set a specific width that fits the column
  height: "auto",  // Let height adjust automatically
  maxWidth: "90%",  // Don't exceed column width
  objectFit: "contain",
  imageRendering: "-webkit-optimize-contrast",
  WebkitBackfaceVisibility: "hidden",
  transform: "translateZ(0)"
};

  // Navigation area styles
  const navAreaStyle = {
    gridArea: "nav",
    position: "relative",
    zIndex: 3,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    paddingTop: `${5 * scaleFactor}px`
  }; 

  // Navigation container with vertical line
  const navContainerStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "auto"
  };

  // Vertical line aligned with nav items height
  const verticalLineStyle = {
    width: `${1 * scaleFactor}px`,
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    marginRight: `${15 * scaleFactor}px`,
    alignSelf: "stretch"  // Stretches to match the height of nav links
  };

  // Nav links container - left aligned to line
  const navLinksStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: `${8 * scaleFactor}px`,
    paddingTop: `${2 * scaleFactor}px`,
    paddingBottom: `${2 * scaleFactor}px`
  };

  // Individual nav link style with scaled font
  const navLinkStyle = {
    color: "rgba(255, 255, 255, 0.7)",  // Light grey
    textDecoration: "none",
    fontSize: `${12 * scaleFactor}px`,
    fontWeight: "400",
    transition: "color 0.3s ease",
    whiteSpace: "nowrap",
    lineHeight: "1.2"
  };

  // Newsletter area styles
  const newsletterAreaStyle = {
    gridArea: "newsletter",
    position: "relative",
    zIndex: 3,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: `${20 * scaleFactor}px`,
    paddingRight: `${40 * scaleFactor}px`
  };

  // Newsletter section container
  const newsletterSectionStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative"
  };

  // Newsletter label with scaled font
  const newsletterLabelStyle = {
    color: "rgba(255, 255, 255, 0.7)",  // Light grey
    fontSize: `${14 * scaleFactor}px`,
    fontWeight: "500",
    marginBottom: `${8 * scaleFactor}px`,
    alignSelf: "flex-start",  // Align to the left of the container
    marginLeft: `calc(100% - ${315 * scaleFactor}px)`  // Position at the start of the form
  };

  // Newsletter form container
  const newsletterFormStyle = {
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "100%",
    maxWidth: `${380 * scaleFactor}px`,  // Increased from 280px to extend further left
    marginLeft: "auto",  // Right-align the form
    paddingLeft: `${5 * scaleFactor}px`  // Move content 5px to the right
  };

  // Email icon style with scaled size
  const emailIconStyle = {
    color: "#f85008",
    fontSize: `${30 * scaleFactor}px`,
    alignSelf: "flex-start",  // Align to the left of the container
    marginLeft: `calc(100% - ${315 * scaleFactor}px)`,  // Position at the start of the form
    marginTop: `-${3 * scaleFactor}px`  // Negative value moves it up
  };

  // Email input style with scaled dimensions - removed borderBottom
  const emailInputStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.05)",  // Subtle white background for blur effect
    backdropFilter: "blur(1px)",  // Very subtle blur effect
    WebkitBackdropFilter: "blur(1px)",  // Safari support
    border: "none",
    borderRadius: `${2 * scaleFactor}px`,  // Match chevron box rounding
    color: "rgba(255, 255, 255, 0.7)",  // Light grey text
    fontSize: `${14 * scaleFactor}px`,
    height: `${25 * scaleFactor}px`,  // Match chevron box height
    padding: `0 ${25 * scaleFactor}px 0 ${10 * scaleFactor}px`,  // Adjusted padding
    marginLeft: `${5 * scaleFactor}px`,  // Move container to the right
    width: "100%",
    outline: "none",
    fontFamily: "Montserrat, sans-serif",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05), inset 0 1px 2px rgba(255, 255, 255, 0.05)",  // Subtle shadow
    boxSizing: "border-box"
  };

  // Separate underline style
  const emailUnderlineStyle = {
    position: "absolute",
    bottom: -2,
    left:50,  // You can adjust this to move the line independently
    right: `-${40 * scaleFactor}px`,  // Extend to compensate for container's right padding
    height: `${1 * scaleFactor}px`,
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    transition: "background-color 0.3s ease"
  };

  // Submit button style with scaled positioning
  const submitButtonStyle = {
    position: "absolute",
    right: `-${40 * scaleFactor}px`,  // Align with underline's right edge
    bottom: `${9 * scaleFactor}px`,
    background: isButtonHovered ? "rgba(248, 80, 8, 0.05)" : "none",  // Subtle orange tint on hover
    border: "none",  // Removed border
    borderRadius: `${2 * scaleFactor}px`,  // Slight rounding
    color: "#f85008",
    fontSize: `${18 * scaleFactor}px`,
    cursor: "pointer",
    width: `${25 * scaleFactor}px`,  // Smaller square dimensions
    height: `${25 * scaleFactor}px`,  // Smaller square dimensions
    padding: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    transform: isButtonPressed 
      ? `scale(0.95) translateX(${isSubmitted ? 10 * scaleFactor : 0}px)` 
      : isSubmitted 
        ? `translateX(${10 * scaleFactor}px)` 
        : "translateX(0)",
    boxShadow: isButtonHovered ? "0 2px 4px rgba(248, 80, 8, 0.1)" : "none"
  };

  // Social media container - right aligned
  const socialContainerStyle = {
    display: "flex",
    flexDirection: "row",
    gap: `${22 * scaleFactor}px`,
    alignItems: "center",
    marginTop: `${14 * scaleFactor}px`,
    justifyContent: "flex-end",
    marginRight: `-${40 * scaleFactor}px`  // Align with underline's right edge
  };

  // Social icon style with scaled dimensions
  const socialIconStyle = {
    width: `${34 * scaleFactor}px`,
    height: `${34 * scaleFactor}px`,
    filter: "brightness(0) saturate(100%) invert(38%) sepia(89%) saturate(2821%) hue-rotate(5deg) brightness(102%) contrast(96%)",
    transition: "transform 0.3s ease",
    cursor: "pointer",
    imageRendering: "-webkit-optimize-contrast",
    WebkitBackfaceVisibility: "hidden",
    transform: "translateZ(0)"
  };

  // Copyright area styles
  const copyrightAreaStyle = {
  gridArea: "copyright",
  position: "relative",
  zIndex: 3,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",  // Changed from "flex-end" to "center"
  borderTop: "none",  // Remove border since we'll use a separate div
  paddingTop: `${2 * scaleFactor}px`  // Changed from paddingBottom to paddingTop
  };

  // Copyright text style with scaled font
  const copyrightStyle = {
    color: "rgba(255, 255, 255, 0.7)",  // Light grey
    fontSize: `${12 * scaleFactor}px`,
    fontWeight: "400",
    textAlign: "center",
    marginTop: `${25 * scaleFactor}px`
  };

  // Top border line - full width
  const topBorderStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    width: "100vw",
    height: `${1 * scaleFactor}px`,
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    zIndex: 4
  };

  return (
    <footer style={footerStyle}>
      {/* Top border - full width */}
      <div style={topBorderStyle}></div>
      {/* Logo Area */}
      <div style={logoAreaStyle}>
        <img src={gigifyLogo} alt="GIGiFY Logo" style={logoStyle} />
      </div>
      
      {/* Navigation Area */}
      <div style={navAreaStyle}>
        <div style={navContainerStyle}>
          <div style={verticalLineStyle}></div>
          <div style={navLinksStyle}>
            <Link 
              to="/privacy-policy" 
              style={navLinkStyle}
              onMouseEnter={(e) => e.target.style.color = "#f85008"}
              onMouseLeave={(e) => e.target.style.color = "rgba(255, 255, 255, 0.7)"}
            >
              Privacy Policy
            </Link>
            <Link 
              to="/service-terms" 
              style={navLinkStyle}
              onMouseEnter={(e) => e.target.style.color = "#f85008"}
              onMouseLeave={(e) => e.target.style.color = "rgba(255, 255, 255, 0.7)"}
            >
              Terms of Service
            </Link>
            <Link 
              to="/community-standards" 
              style={navLinkStyle}
              onMouseEnter={(e) => e.target.style.color = "#f85008"}
              onMouseLeave={(e) => e.target.style.color = "rgba(255, 255, 255, 0.7)"}
            >
              Community Standards
            </Link>
            <Link 
              to="/performance-agreement" 
              style={navLinkStyle}
              onMouseEnter={(e) => e.target.style.color = "#f85008"}
              onMouseLeave={(e) => e.target.style.color = "rgba(255, 255, 255, 0.7)"}
            >
              Performance Agreement
            </Link>
          </div>
        </div>
      </div>
      
      {/* Newsletter and Social Area */}
      <div style={newsletterAreaStyle}>
        <div style={newsletterSectionStyle}>
          <div style={newsletterLabelStyle}>Subscribe to our Newsletter</div>
          <form onSubmit={handleSubmit} style={newsletterFormStyle}>
            <span style={emailIconStyle}>✉</span>
            <input
              type="email"
              placeholder="Enter your e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={emailInputStyle}
              onFocus={() => setIsInputFocused(true)}
              onBlur={() => setIsInputFocused(false)}
              required
            />
            <div style={{
              ...emailUnderlineStyle,
              backgroundColor: isInputFocused ? "#f85008" : "rgba(255, 255, 255, 0.5)"
            }}></div>
            <button
              type="submit"
              style={submitButtonStyle}
              onMouseEnter={() => setIsButtonHovered(true)}
              onMouseLeave={() => setIsButtonHovered(false)}
              onMouseDown={() => setIsButtonPressed(true)}
              onMouseUp={() => setIsButtonPressed(false)}
            >
              {isSubmitted ? "✓" : "❯"}
            </button>
          </form>
          
          {/* Social Media Icons - right aligned */}
          <div style={socialContainerStyle}>
            <a 
              href="https://linkedin.com" 
              target="_blank" 
              rel="noopener noreferrer"
              onMouseEnter={(e) => e.currentTarget.firstChild.style.transform = `scale(1.1) translateZ(0)`}
              onMouseLeave={(e) => e.currentTarget.firstChild.style.transform = "scale(1) translateZ(0)"}
            >
              <img src={linkedinIcon} alt="LinkedIn" style={socialIconStyle} />
            </a>
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              onMouseEnter={(e) => e.currentTarget.firstChild.style.transform = `scale(1.1) translateZ(0)`}
              onMouseLeave={(e) => e.currentTarget.firstChild.style.transform = "scale(1) translateZ(0)"}
            >
              <img src={instagramIcon} alt="Instagram" style={socialIconStyle} />
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
              onMouseEnter={(e) => e.currentTarget.firstChild.style.transform = `scale(1.1) translateZ(0)`}
              onMouseLeave={(e) => e.currentTarget.firstChild.style.transform = "scale(1) translateZ(0)"}
            >
              <img src={twitterIcon} alt="X (Twitter)" style={socialIconStyle} />
            </a>
            <a 
              href="https://facebook.com" 
              target="_blank" 
              rel="noopener noreferrer"
              onMouseEnter={(e) => e.currentTarget.firstChild.style.transform = `scale(1.1) translateZ(0)`}
              onMouseLeave={(e) => e.currentTarget.firstChild.style.transform = "scale(1) translateZ(0)"}
            >
              <img src={facebookIcon} alt="Facebook" style={socialIconStyle} />
            </a>
          </div>
        </div>
      </div>
      
      {/* Copyright Area */}
      <div style={copyrightAreaStyle}>
        {/* Line above copyright - full width */}
        <div style={{
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "100vw",
          height: `${1 * scaleFactor}px`,
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          zIndex: 4
        }}></div>
        <div style={copyrightStyle}>
          © 2025 GIGIFY. All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default DesktopFooter;